import { useState } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";

import { Delete as DeleteIcon, Edit as EditIcon } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import { SellerBankAccountFormDialog } from "../seller-bank-account-form-dialog";

export const SellerBankAccountsSection = () => {
  const { control } = useFormContext();
  const {
    fields: sellerBankAccounts,
    append,
    update,
    remove,
  } = useFieldArray({
    control,
    name: "sellerBankAccounts",
  });
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const rows = sellerBankAccounts.map((sellerBankAccount, index) => ({
    ...sellerBankAccount,
    index,
  }));

  const columns = [
    {
      field: "accountNumber",
      headerName: "No. Rek.",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "accountHolder",
      headerName: "Atas Nama",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "bank",
      headerName: "Bank",
      flex: 1.5,
      sortable: false,
      renderCell: ({ row }) => row.bank?.name,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Aksi",
      width: 100,
      getActions: ({ row }) => [
        <GridActionsCellItem
          key="edit"
          icon={<EditIcon />}
          label="Ubah"
          onClick={() => setEditIndex(row.index)}
        />,
        <GridActionsCellItem
          key="delete"
          icon={<DeleteIcon />}
          label="Hapus"
          color="error"
          onClick={() => remove(row.index)}
        />,
      ],
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2">Rekening Bank</Typography>
          <Button variant="outlined" onClick={() => setIsAddDialogOpen(true)}>
            Tambah
          </Button>
        </Stack>
      </Grid>
      <Grid size={12}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick
          disableColumnMenu
          hideFooter
          localeText={{ noRowsLabel: "Belum ada rekening bank." }}
        />
      </Grid>
      {isAddDialogOpen && (
        <SellerBankAccountFormDialog
          onClose={() => setIsAddDialogOpen(false)}
          onSubmit={(data) => {
            append(data);
            setIsAddDialogOpen(false);
          }}
        />
      )}
      {editIndex != null && (
        <SellerBankAccountFormDialog
          defaultValues={sellerBankAccounts[editIndex]}
          onClose={() => setEditIndex(null)}
          onSubmit={(data) => update(editIndex, data)}
        />
      )}
    </Grid>
  );
};
